$(document).ready(function () {

    var table = $('#example_table').DataTable();

    $("#form-report-campaign").on('submit', function (e) {
       e.preventDefault();
       let data = new FormData(this)
       sendData(data,'get-report-by-campaign','div_result_report_campaign')
   })

    $("#form-report-movements").on('submit', function (e) {
        e.preventDefault();
        let data = new FormData(this)
        sendData(data,'get-report-movements','div_result_report_movements')
        $('#example_table').DataTable();

    })

    function sendData(data, route,div_id) {
        togglePreloader();
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(() => {
                    togglePreloader();
                    document.getElementById(div_id).innerHTML = response;
                    console.log(response)
                    if (div_id === "div_result_report_movements") {
                        table.destroy();
                        table = $('#example_table').DataTable();
                    }
                }, "1000");

            }, error: function (errors, xhr, status,) {
                togglePreloader();
                var indices = errors.responseJSON.errors;

            }
        })
    }

    $("#btn_search_amount").on('click', function (){
        togglePreloader();
        let campaignUuid = $('#campaign_uuid').val();
        let route = "/get-result-campaign-by-month"
        let data = new FormData()
        data.append('uuid', campaignUuid)

        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                console.log(response)
                setTimeout(() => {
                    togglePreloader();
                    let html = `
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Mes</th>
                                <th>Total</th>
                                <th>Sucursales</th>
                            </tr>
                        </thead>
                        <tbody>
                `;

                    response.forEach(item => {
                        // Construir el detalle de sucursales
                        let sucursalesHtml = item.sucursales.map(s =>
                            `<span class="badge badge-info mr-1">
                            ${s.nombre}: $${parseFloat(s.total).toFixed(2)}
                        </span>`
                        ).join('');

                        html += `
                        <tr>
                            <td>${item.mes}</td>
                            <td>$${parseFloat(item.total).toFixed(2)}</td>
                            <td>${sucursalesHtml}</td>
                        </tr>
                    `;
                    });

                    html += `</tbody></table>`;

                    $('#div_table_results').html(html);
                }, "1000");

            }, error: function (errors, xhr, status) {
                togglePreloader();
                var indices = errors.responseJSON.errors;
            }
        })
    });
});
